"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactComponents = require("@ui-propulsion/react-components");
var _SingleAccount = require("./SingleAccount.styles");
function SingleAccount(_ref) {
  var bankAccount = _ref.bankAccount;
  var classes = (0, _SingleAccount.useStyles)();
  return /*#__PURE__*/_react["default"].createElement(_reactComponents.Container, {
    className: classes.root,
    "data-testid": "singleAccount"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.accountContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.accountCheckContainer
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Checkbox, {
    id: "single-account-checkbox",
    className: classes.accountIcon,
    checked: true,
    disabled: true
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.account
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.institution
  }, "".concat(bankAccount.institutionName, " ").concat(bankAccount.accountName, " (****").concat(bankAccount.lastFour, ")")), bankAccount.balance && /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.balance
  }, "Current balance: ".concat(bankAccount.balance)))));
}
SingleAccount.propTypes = {
  /**
   * Account properties
   */
  bankAccount: (0, _propTypes.shape)({
    institutionName: _propTypes.string,
    accountName: _propTypes.string,
    lastFour: _propTypes.string,
    balance: _propTypes.string
  }).isRequired
};
var _default = SingleAccount;
exports["default"] = _default;
